module.exports = __webpack_public_path__ + "img/2.8cb26f2d.png";